import $, { type } from 'jquery';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Modals from 'root/modals';
import UI from 'root/ui';
import Util from 'root/module/util';
import Modal from 'root/module/modal';
import View from 'view/base';

export default View.extend({
    className: 'project-members-manage',

    events: {
        'click .member-invite'           : 'onInviteMember',
        'click .member-add'              : 'onAddMember',
        'click .member-added'            : 'onRemoveMember',
        'click .member-access li'        : 'onMemberAccessChange',
        'click .invitation-pending'      : 'onRemoveInvitation',
        'click .invitation-add'          : 'onAddInvitation',
        'click .account-upgrade'         : 'onUpgradeAccount',
        'mouseenter .member-added'       : 'onMouseEnterAdded',
        'mouseleave .member-added'       : 'onMouseLeaveAdded',
        'mouseenter .invitation-pending' : 'onMouseEnterAdded',
        'mouseleave .invitation-pending' : 'onMouseLeaveAdded'
    },

    dom_handlers: {
        onUpgradeAccount: function(e) {
            Modals.choosePlan();
        },

        onInviteMember: function(e) {
            e.preventDefault();
            Modals.inviteUser();
        },

        onAddMember: function(e) {
            var button = $(e.currentTarget);
            var user_id = button.data('val');

            Cache.app.request({
                action: 'project_access/create',
                data: {
                    project_id: this.model.id,
                    user_id: user_id
                },
                success: (response) => {
                    Cache.project_access.add(response);

                    button.removeClass('member-add tertiary').addClass('member-added success').html('<i class="fa-regular fa-check"></i> Added');

                    UI.success(Cache.user.get(user_id).get('name') + ' added to the project');
                }
            });

        },

        onRemoveMember: function(e) {
            var button = $(e.currentTarget);
            var user_id = button.data('val');

            Cache.app.request({
                action: 'project_access/delete',
                data: {
                    project_id: this.model.id,
                    user_id: user_id
                },
                success: () => {
                    Cache.project_access.searchAndRemove({
                        project_id: this.model.id,
                        user_id: user_id
                    });

                    button.removeClass('member-added success').addClass('member-add tertiary').text('Add');

                    UI.success(Cache.user.get(user_id).get('name') + ' removed from the project');
                }
            });
        },

        onMemberAccessChange: function(e) {
            var el = $(e.currentTarget).parent();
            var user_id = el.data('id');
            var type = el.data('type');
            var access = $(e.currentTarget).data('value');

            if (type === 'invitation') {
                Cache.user_invitation.findWhere({id: user_id}).setAccess(Constants.ACCESS_PUBLIC_COMMENT, access, this.model.id)
            } else {
                var member = Cache.workspace_member.findWhere({user_id: user_id});

                member.setAccess(Constants.ACCESS_PUBLIC_COMMENT, access, this.model.id);
            }

            UI.success('Changes saved.');
        },

        onRemoveInvitation: function(e) {
            var invitation_id = $(e.currentTarget).data('val');
            var invitation = Cache.user_invitation.get(invitation_id);

            if (invitation.get('project_ids').split(',').length === 1) {
                // withdraw invitation
                var confirm_text = invitation.get('role') === Constants.ADMIN ?
                    '<p>Removing this admin member will withdraw the invitation. Are you sure you want to withdraw the invitation?</p>' :
                    '<p>Removing a pending member from the only project will withdraw the invitation. Are you sure you want to withdraw the invitation?</p>';

                Modal.confirm(confirm_text, function() {
                    Cache.app.request({
                        action: 'user_invitation/delete',
                        data: {
                            id: invitation_id
                        },
                        success: () => {
                            Cache.app.trackEvent('Member Deleted');

                            Cache.user_invitation.remove(invitation_id);
                            UI.success('Invitation deleted');
                        }
                    });
                }, this, 'Yes, withdraw', 'Withdraw invitation', 'secondary');
            } else {
                // remove from project
                Cache.app.request({
                    action: 'user_invitation/removeProject',
                    data: {
                        id: invitation_id,
                        project_id: this.model.id
                    },
                    success: (response) => {
                        invitation.set(response);
                        UI.success(invitation.get('email') + ' removed from the project');
                    }
                });
            }
        },

        onAddInvitation: function(e) {
            var invitation_id = $(e.currentTarget).data('val');
            var invitation = Cache.user_invitation.get(invitation_id);

            // add invitation to the project
            Cache.app.request({
                action: 'user_invitation/addProject',
                data: {
                    id: invitation_id,
                    project_id: this.model.id
                },
                success: (response) => {
                    invitation.set(response);
                    UI.success(invitation.get('email') + ' added to the project');
                }
            });
        },

        onMouseEnterAdded: function(e) {
            $(e.currentTarget).removeClass('success').addClass('secondary').text('Remove');
        },

        onMouseLeaveAdded: function(e) {
            $(e.currentTarget).removeClass('secondary').addClass('success').html('<i class="fa-regular fa-check"></i> Added');
        }
    },

    event_handlers: {
        onInvitationAdd: function(model) {
            var new_invitation = this.renderInvitation(model);
            this.$el.find('.region-invitations').append(new_invitation);
        },

        onInvitationRemove: function(model) {
            this.$el.find('.invitation-preview[data-val="' + model.id + '"]').remove();
        },

        onInvitationChange: function(model) {
            this.$el.find('.invitation-preview[data-val="' + model.id + '"]').replaceWith(this.renderInvitation(model));
        }
    },

    initialize: function() {
        this.listenTo(Cache.user_invitation, 'add',    this.event_handlers.onInvitationAdd);
        this.listenTo(Cache.user_invitation, 'remove', this.event_handlers.onInvitationRemove);
        this.listenTo(Cache.user_invitation, 'change', this.event_handlers.onInvitationChange);
    },

    renderMemberAccess: function(type, model) {
        if (this.model.isSurvey()) {
            return '';
        }

        var project_id = this.model.id;

        var html = '';

        if (model) {
            var model_id = type === 'invitation' ? model.id : model.get('user_id');
            var disabled = type === 'invitation' ? false : Cache.real_user_id === model.get('user_id');
            var html =
            '<div class="member-access button-dropdown button-dropdown-left" data-update="true" data-append="true">' +
                 '<button type="button" class="dropdown-select dropdown-select-small dropdown-select-text-invert"' + (disabled ? ' disabled' : '') + '>' +
                     (model.hasAccess(Constants.ACCESS_PUBLIC_COMMENT, project_id) ? 'All comments' : 'Internal notes only') +
                 '</button>' +
                 '<div>' +
                     '<ul class="dropdown dropdown-select" data-id="' + model_id + '" data-type="' + type + '">' +
                         '<li class="' + (model.hasAccess(Constants.ACCESS_PUBLIC_COMMENT, project_id) ? 'selected' : '') +'" data-value="true">All comments</li>' +
                         '<li class="' + (model.hasAccess(Constants.ACCESS_PUBLIC_COMMENT, project_id) ? '' : 'selected') +'" data-value="false">Internal notes only</li>' +
                     '</ul>' +
                 '</div>' +
             '</div>';
        }

        return html;
    },

    renderInvitation: function(model) {
        var project_ids = model.get('project_ids').split(',').map((project_id)=> {
            return parseInt(project_id, 10)
        });

        var html =
        '<div class="member-preview invitation-preview" data-val="' + model.id + '">' +
            '<div class="flex-start">' +
                '<img class="user-32" src="' + Util.gravatar(model.get('email'), 32) + '">' +
            '</div>' +
            '<div>' +
                '<div class="tooltip" data-title="Invitation sent: ' + Util.moment(model.get('time'), 'DD MMM YYYY HH:hh A') + '">' + model.escape('email') + '</div>' +
                (this.renderMemberAccess('invitation', model)) +
            '</div>' +
            (model.get('role') === Constants.ADMIN || project_ids.includes(this.model.id) ?
            '<button type="button" class="invitation-pending small success" data-val="' + model.id + '"><i class="fa-regular fa-check"></i> Added</button>' :
            '<button type="button" class="invitation-add small tertiary" data-val="' + model.id + '">Add</button>') +
        '</div>';

        return html;
    },

    render: function() {
        var members = '';
        var invitations = '';

        var project_id = this.model.id;
        var project_users = Cache.app.getUsersByProject(project_id, undefined, 'id');
        var project_user_ids = [];

        // invited members
        project_users.forEach((user) => {
            var member = Cache.workspace_member.findWhere({user_id: user.id});

            project_user_ids.push(user.id);

            members +=
            '<div class="member-preview">' +
                '<div class="flex-start">' +
                    '<img class="user-32" src="' + user.getAvatar(32) + '">' +
                '</div>' +
                '<div class="flex-start">' +
                    '<div>' +
                        '<div class="font-weight-medium">' + user.escape('name') + '</div>' +
                        (this.renderMemberAccess('member', member)) +
                    '</div>' +
                '</div>' +
                '<div>' +
                    (member.get('role') === Constants.ADMIN ?
                    '<button type="button" data-val="' + user.id + '" class="small success tooltip disabled" data-title="Admin user cannot be removed from a project"><i class="fa-regular fa-check"></i> Added</button>' :
                    '<button type="button" data-val="' + user.id + '" class="member-added small success"><i class="fa-regular fa-check"></i> Added</button>') +
                '</div>' +
            '</div>';
        });

        // others
        Cache.workspace_member.each((member) => {
            var user = Cache.user.get(member.get('user_id'));

            if (!user || project_user_ids.indexOf(user.id) !== -1) {
                return;
            }

            if (member.get('is_disabled')) {
                return;
            }

            members +=
            '<div class="member-preview">' +
                '<div class="flex-start">' +
                    '<img class="user-32" src="' + user.getAvatar(32) + '">' +
                '</div>' +
                '<div class="flex-start">' +
                    '<div>' +
                        '<div class="font-weight-medium">' + user.escape('name') + '</div>' +
                        (this.renderMemberAccess('member', member)) +
                    '</div>' +
                '</div>' +
                '<div>' +
                    '<button type="button" data-val="' + user.id + '" class="member-add small tertiary">Add</button>' +
                '</div>' +
            '</div>';
        });

        // invitations
        Cache.user_invitation.each((model) => {
            invitations += this.renderInvitation(model);
        });

        var content =
            'Add or remove members' +
            '<div class="region-project-access">' +
                '<div class="region-members">' +
                    members +
                '</div>' +
                '<div class="region-invitations">' +
                    invitations +
                '</div>' +
            '</div>' +
            '<div class="flex-between">' +
                '<a class="member-invite primary font-weight-medium" href="#"><i class="fa-regular fa-plus"></i> Invite new members</a>' +
                (Cache.account.hasFeature('user_restriction') ? '' :
                '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
            '</div>';

        this.$el.html(content);

        return this;
    }
});